import(/* webpackMode: "eager" */ "/codebuild/output/src3146945838/src/apps/webapp/src/app/global-error.tsx");
